import React from "react";
import AvatarPage from "../../../../avatar-page";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

const Gallery = (props) => {
   const { card } = props;
   const images = card?.images;
   const settings = {
      dots: true,
      infinite: false,
      slidesToShow: 1.2,
      slidesToScroll: 1,
      autoplay: false,
      // nextArrow: <div className="card-arrow__item card-arrow__item--left"><i></i></div>,
      // prevArrow: <div className="card-arrow__item card-arrow__item--right"><i></i></div>
   };
   return (
      <div className="row-wrapper">
         <div className="">
            <AvatarPage />
         </div>
         <div className="row-wrapper__children">
            <div className="card-arrow">
               <div className="">
                  <Slider {...settings}>
                     {images?.map((image, index) => (
                        <div className="card-gallery__item" key={index}>
                           <div>
                              <img src={image.image_url} alt="image in gallery" className="card-gallery__image card-gallery__image--horizontal" />
                           </div>
                           <div className="card-gallery__info">
                              <div>
                                 <p className="over-three-lines">{image.title}</p>
                                 <p className="">{image.title}</p>
                              </div>
                              {image?.buttons?.map((button, index2) => (
                                 <div className="card__btn-container" key={index2}>
                                    <p className="">{button.title}</p>
                                 </div>
                              ))}
                           </div>
                        </div>
                     ))}
                  </Slider>
               </div>
               {/* {images && images.length > 1 &&
                  <React.Fragment>
                     <div className="card-arrow__item card-arrow__item--left"><i></i></div>
                     <div className="card-arrow__item card-arrow__item--right"><i></i></div>
                  </React.Fragment>
               } */}
            </div>
         </div>
      </div>
   )
}

export default Gallery;